import { CollectionStory } from '@amzn/awscat-pattern-library-service-model';
import { v4 as uuid } from 'uuid';

/**
 * Editable story in the collection editor; `index` is its current position and `id` is a
 * client-only identity that is never sent to the backend.
 */
class CollectionStoryWithIndex {
  readonly id: string;
  story: CollectionStory;
  index: number;
  url?: string;
  searchTerm?: string;
  addedPublication?: boolean;

  constructor(
    story: CollectionStory,
    index: number,
    url?: string,
    searchTerm?: string,
    addedPublication?: boolean,
    id: string = uuid(),
  ) {
    this.id = id;
    this.story = story;
    this.index = index;
    this.url = url;
    this.searchTerm = searchTerm;
    this.addedPublication = addedPublication;
  }
}

export default CollectionStoryWithIndex;
